import BaseErrorPage from '../../../Components/BaseErrorPage'

interface MissingVenueErrorPageProps {
  accessSecret: string
}

const MissingVenueErrorPage = ({
  accessSecret,
}: MissingVenueErrorPageProps): JSX.Element => (
  <BaseErrorPage accessSecret={accessSecret}>
    Unfortunately the message and space you are looking for are no longer
    available.
  </BaseErrorPage>
)

export default MissingVenueErrorPage
